<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>
          <ng-container *ngIf="Id === 0;else load_else " translate>
            lblAddWarningLight
          </ng-container>
          <ng-template #load_else translate>
            lblEditWarningLight
          </ng-template>
        </div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
          </a>
        </div>

      </div>
      <form [formGroup]="WarningLightForm" (ngSubmit)="addEditWarningLightForm()">
        <div class=" scrollbar">
          <div class="card-content">
            <div class="card-body p-0">

              <div >
                <div class="form-row" *ngIf="t.controls">
                  <div class="col-lg-6 col-xl-3" *ngFor="let ticket of t.controls; let i = index">
                    <div [formGroup]="ticket">
                      <div class="af-form-group">
                        <label for="name"><span translate>lblName</span><span> in
                            {{languageList[i].value}}</span>
                          <strong class="mlt6 required"> * </strong> </label>
                        <div class="lbl-info">
                          <input formControlName="name" class="form-control mb-2" maxlength="100"
                            [ngClass]="{'is-invalid': cpf.warningLight.invalid && cpf.warningLight.touched}">
                          <div *ngIf="cpf.warningLight.touched && (cpf.warningLight.errors?.required)"
                            class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                              aria-hidden="true"></em>
                            lblNameRequired
                          </div>
                        </div>
                      </div>

                      <div class="af-form-group" style="display: none;">
                        <label for="languageId" translate>Language Id</label>
                        <div class="lbl-info">
                          <input formControlName="languageId" class="form-control mb-2" [ngModel]="languageList[i].id"
                            maxlength="30">
                        </div>
                      </div>

                      <div class="af-form-group">
                        <label for="description"><span translate>lblDescription</span><span> in
                            {{languageList[i].value}}</span>
                          <strong class="mlt6 required"> * </strong> </label>
                        <div class='lbl-info'>
                          <input formControlName="description" class="form-control mb-2" maxlength="500"
                            [ngClass]="{'is-invalid': cpf.warningLight.invalid && cpf.warningLight.touched}">
                          <div *ngIf="cpf.warningLight.touched && (cpf.warningLight.errors?.required)"
                            class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                              aria-hidden="true"></em>
                            lblDescriptionIsRequired
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>

              <div class="form-row">
              <div class="col-lg-6 col-xl-3 af-form-group">
                <label for="logo" translate>lblLogo
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class='lbl-info d-flex align-items-center'>
                  <ng-container *ngIf="image; ">
                    <div class="border mb-3 p-1 d-inline-block mr-3">
                      <img af-image [data-code]="warningLightDetail ? warningLightDetail.warningLightDetails[0].logo : null" [data-src]="image" id="UploadImage" width="50px" alt="">
                    </div>
                  </ng-container>
                  <div>
                    <span>
                    <label class="btn btn-outline-primary d-inline-block " for="select-files"
                      translate>lblUploadLogo</label>
                    <input type="file" id="select-files" formcontrolName="Image" hidden name="FUImage"
                      accept=".png, .jpg, .jpeg, .svg" (change)="onChangeFileUpload($event.target.files)">
                    </span>                     
                    <p class="text-muted">
                      <small translate>lblAllowedJPGPNGSVG</small>
                    </p>
                    <div *ngIf="cpf.Image.touched && (cpf.Image.errors?.required)"
                            class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                              aria-hidden="true"></em>
                            lblImageRequired
                      </div>
                  </div>
                </div>
              </div>
              <div class="col-3 mt-2">
                <div class="af-form-group mt-4">
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="isActive" [checked]="WarningLightForm.value.isActive"
                      (change)="onChangeIsActive($event)">
                    <label class="custom-control-label" for="isActive">
                      <span translate>lblActive</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
          <div class="row">
            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
              <button type="submit" class="btn btn-primary btn-lg mr-sm-2" *ngIf="Id == 0" aria-label="Center Align"
                [disabled]="!WarningLightForm.valid" translate><em class="fa fa-plus font16 align-top mr-2"></em>lblAdd
              </button>
              <button type="submit" class="btn btn-primary btn-lg mr-sm-2" *ngIf="Id != 0" aria-label="Center Align"
                [disabled]="!WarningLightForm.valid" translate><em
                  class="far fa-save font16 align-top mr-2"></em>lblUpdate
              </button>
              <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg" translate><em
                  class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>